/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TerraceInputs */

const cs_enum_terrace = /** @type {(inputs: Enum_TerraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terasa`)
};

const en_enum_terrace = /** @type {(inputs: Enum_TerraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrace`)
};

/**
* | output |
* | --- |
* | "Terrace" |
*
* @param {Enum_TerraceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_terrace = /** @type {((inputs?: Enum_TerraceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TerraceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_terrace(inputs)
	return cs_enum_terrace(inputs)
});